import React from 'react';
import { useParams } from 'react-router-dom';
import BasicPrint from './BasicPrint';
import Locations from './Locations';
import CategoryAnalysis from './CategoryAnalysis';
import DataReports from './DataReports';
import NamingReport from '../BasicReport/NamingReport';
import ReportHistory from './ReportHistory';
import DataReport from './analytical-report/DataReport';
import ImageReport from './analytical-report/ImageReport';
import ReportByObj from './object-report/ReportByObj';
import ReportByNegative from './negative-report/ReportByNegative';
import BibliographyReport from './bibliography';
import ImagePublicationVariants from './bibliography/ImagePublicationVariants';
import ImagePublication from './bibliography/ImagePublication';
import Bibliography from './bibliography/Bibliography';
import PublishedImage from './bibliography/PublishedImage';

const Reports = props => {
  const { section, section_2, id } = useParams();
  const currentTab = () => {
    switch (section) {
      case 'cataloging-report':
        if (id === 'naming-convention-report') {
          return <NamingReport {...props} />;
        } else if (id === 'basic-print') {
          return <BasicPrint {...props} />;
        } else if (id === 'catalog-report') {
          return <BasicPrint {...props} />;
        }
      case 'analytical-report':
        if (id === 'data-report') {
          return <DataReport {...props} />;
        } else if (id === 'image-report') {
          return <ImageReport {...props} />;
        }

      // case 'basic-reports':
      //   return id === 'naming-convention-report' ? <NamingReport {...props} /> : <BasicPrint {...props} />;
      // case 'locations':
      //   return <Locations {...props} />;
      // case 'category-analysis':
      //   return <CategoryAnalysis {...props} />;
      case 'reading-reports':
        return id === 'locations' ? <Locations {...props} /> : <CategoryAnalysis {...props} />;
      case 'data-reports':
        return <DataReports {...props} />;
      case 'report-history':
        return <ReportHistory {...props} />;
      case 'report-by-object':
        return <ReportByObj {...props} />;
      case 'report-by-negative':
        return <ReportByNegative {...props} />;
      case 'bibliography-report':
        if (id === 'plate-inventory') {
          return <BibliographyReport {...props} />;
        } else if (id === 'image-pub-list') {
          return <ImagePublication {...props} />;
        } else if (id === 'pub-list-with-variants') {
          return <ImagePublicationVariants {...props} />;
        } else if (id === 'biblio-rpt') {
          return <Bibliography {...props} />;
        } else if (id === 'published-images') {
          return <PublishedImage {...props} />;
        }
      default:
        return <BasicPrint {...props} />;
    }
  };
  return <div>{currentTab()}</div>;
};

export default Reports;
